export { SearchHero } from './search-hero';
